import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { Url, USER_PROFILE_SHOP_SUB_PATHS, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import s from './MoneyPromoButton.scss';
const MoneyPromoButton = ({ user, moneyPromo, relevantDeviation })=>{
    const { t } = useTranslation();
    const seller_promo_banners = useFlag('seller_promo_banners');
    let biEvid = null;
    let link = null;
    if (moneyPromo === 'tier') {
        biEvid = BiEventType.VIEW_SUBSCRIPTION_TAB;
        link = Url.userSubscriptionsPath({
            username: user.username
        });
    } else if (moneyPromo === 'adoptable') {
        biEvid = BiEventType.VIEW_ADOPTABLES_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.EXCLUSIVES);
    } else if (moneyPromo === 'commission') {
        biEvid = BiEventType.VIEW_COMMISSIONS_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
    } else if (moneyPromo === 'premium_gallery') {
        biEvid = BiEventType.VIEW_PREMIUM_GALLERIES_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
    }
    if (seller_promo_banners && moneyPromo !== 'tier') {
        link = Url.userLink(user.username, USER_PROFILE_SECTION_PATHS.SHOP);
    }
    if (!link) {
        return null;
    }
    let ctaKey;
    if (seller_promo_banners) {
        if (moneyPromo === 'tier') {
            ctaKey = `seller_promo_banners.submissionDetailsHeader.moneyPromo.var.tier.CTA`;
        } else {
            ctaKey = `seller_promo_banners.submissionDetailsHeader.moneyPromo.var.generic.CTA`;
        }
    } else {
        ctaKey = `submissionDetailsHeader.moneyPromo.var.${moneyPromo}.CTA`;
    }
    return /*#__PURE__*/ React.createElement(BiLink, {
        className: s['root'],
        href: link,
        biData: relevantDeviation && biEvid ? BiData({
            evid: biEvid,
            typeid: relevantDeviation.typeId,
            itemid: relevantDeviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        }) : undefined
    }, t(ctaKey));
};
MoneyPromoButton.displayName = 'MoneyPromoButton';
export default MoneyPromoButton;
